import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-faculty-create',
  templateUrl: './faculty-create.component.html',
  styleUrls: ['./faculty-create.component.scss']
})
export class FacultyCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public departments = [];
  public Form: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/facultybyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              image: data.data.image,
              name: data.data.name,
              department: data.data.department,
              designation: data.data.designation,
              otherdetails: data.data.otherdetails,
              email: data.data.email,
              phone: data.data.phone,
              office: data.data.office,
              googleProfile: data.data.googleProfile,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
      data => {
        // console.log(data.data);
        this.departments = data.data;
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.Form = this.formBuilder.group({
      image: ['', Validators.required],
      name: ['', Validators.required],
      department: ['', Validators.required],
      designation: ['', Validators.required],
      googleProfile: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      office: ['', Validators.required],
      otherdetails: ['', ],
      _id: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "image" : this.Form.value.image,
      "name" : this.Form.value.name,
      "department" : this.Form.value.department,
      "designation" : this.Form.value.designation,
      "otherdetails" : this.Form.value.otherdetails,
      "googleProfile" : this.Form.value.googleProfile,
      "email" : this.Form.value.email,
      "phone" : this.Form.value.phone,
      "office" : this.Form.value.office,
      "admin" : sessionStorage.getItem('adminName'),
      "url" : this.Form.value.name.toLowerCase().replace(/ /g, '-'),
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/faculty', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/faculty/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "image" : this.Form.value.image,
      "name" : this.Form.value.name,
      "department" : this.Form.value.department,
      "designation" : this.Form.value.designation,
      "otherdetails" : this.Form.value.otherdetails,
      "googleProfile" : this.Form.value.googleProfile,
      "email" : this.Form.value.email,
      "phone" : this.Form.value.phone,
      "office" : this.Form.value.office,
      "admin" : sessionStorage.getItem('adminName'),
      "url" : this.Form.value.name.toLowerCase().replace(/ /g, '-'),
      "_id" : this.Form.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/faculty/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/faculty/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
